module.exports = __webpack_public_path__ + "static/media/explosion.fd3e1d6f.png";